@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import dev.lingvo.ops.pages.IndexPage as _dev_lingvo_ops_pages_IndexPage
import dev.lingvo.ops.pages.JobsPage as _dev_lingvo_ops_pages_JobsPage
import dev.lingvo.ops.pages.LogPage as _dev_lingvo_ops_pages_LogPage
import dev.lingvo.ops.pages.LoginPage as _dev_lingvo_ops_pages_LoginPage
import dev.lingvo.ops.pages.OpsAuthCallbackPage as _dev_lingvo_ops_pages_OpsAuthCallbackPage
import dev.lingvo.ops.pages.PlatformPage as _dev_lingvo_ops_pages_PlatformPage
import dev.lingvo.ops.pages.SearchPage as _dev_lingvo_ops_pages_SearchPage
import dev.lingvo.ops.pages.UsersPage as _dev_lingvo_ops_pages_UsersPage
import dev.lingvo.ops.pages.WebhooksPage as _dev_lingvo_ops_pages_WebhooksPage
import dev.lingvo.ops.pages.WorkspacesPage as _dev_lingvo_ops_pages_WorkspacesPage
import dev.lingvo.ops.pages.jobs.jobId.JobPage as _dev_lingvo_ops_pages_jobs_jobId_JobPage
import dev.lingvo.ops.pages.users.userId.UserPage as _dev_lingvo_ops_pages_users_userId_UserPage
import dev.lingvo.ops.pages.webhooks.WebhookDetailPage as _dev_lingvo_ops_pages_webhooks_WebhookDetailPage
import dev.lingvo.ops.pages.workspaces.AuditPage as _dev_lingvo_ops_pages_workspaces_AuditPage
import dev.lingvo.ops.pages.workspaces.orgId.BillingPage as _dev_lingvo_ops_pages_workspaces_orgId_BillingPage
import dev.lingvo.ops.pages.workspaces.orgId.ProvidersPage as _dev_lingvo_ops_pages_workspaces_orgId_ProvidersPage
import dev.lingvo.ops.pages.workspaces.orgId.WorkspacePage as _dev_lingvo_ops_pages_workspaces_orgId_WorkspacePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Lingvo operator console"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_IndexPage()
        }
        ctx.router.register(
            "/auth/callback",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_OpsAuthCallbackPage()
        }
        ctx.router.register(
            "/jobs",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_JobsPage()
        }
        ctx.router.register(
            "/jobs/{jobId}",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_jobs_jobId_JobPage()
        }
        ctx.router.register(
            "/log",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_LogPage()
        }
        ctx.router.register(
            "/login",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_LoginPage()
        }
        ctx.router.register(
            "/platform",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_PlatformPage()
        }
        ctx.router.register(
            "/search",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_SearchPage()
        }
        ctx.router.register(
            "/users",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_UsersPage()
        }
        ctx.router.register(
            "/users/{userId}",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_users_userId_UserPage()
        }
        ctx.router.register(
            "/webhooks",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_WebhooksPage()
        }
        ctx.router.register(
            "/webhooks/{webhookId}",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_webhooks_WebhookDetailPage()
        }
        ctx.router.register(
            "/workspaces",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_WorkspacesPage()
        }
        ctx.router.register(
            "/workspaces/{orgId}",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_workspaces_orgId_WorkspacePage()
        }
        ctx.router.register(
            "/workspaces/{orgId}/audit",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_workspaces_AuditPage()
        }
        ctx.router.register(
            "/workspaces/{orgId}/billing",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_workspaces_orgId_BillingPage()
        }
        ctx.router.register(
            "/workspaces/{orgId}/providers",
        ) { pageCtx -> 
            _dev_lingvo_ops_pages_workspaces_orgId_ProvidersPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("ops-platform-grid", dev.lingvo.ops.components.OpsPlatformGridStyle)
        ctx.theme.registerStyle("ops-prose", dev.lingvo.ops.components.OpsProseStyle)
        ctx.theme.registerStyle("ops-panel-header", dev.lingvo.ops.components.OpsPanelHeaderStyle)
        ctx.theme.registerStyle("ops-page-header", dev.lingvo.ops.components.OpsPageHeaderStyle)
        ctx.theme.registerStyle("ops-workspace-nav", dev.lingvo.ops.components.OpsWorkspaceNavStyle)
        ctx.theme.registerStyle("ops-shell-root", dev.lingvo.ops.components.OpsShellRootStyle)
        ctx.theme.registerStyle("ops-chrome", dev.lingvo.ops.components.OpsChromeStyle)
        ctx.theme.registerStyle("ops-header", dev.lingvo.ops.components.OpsHeaderStyle)
        ctx.theme.registerStyle("ops-header-lockup", dev.lingvo.ops.components.OpsHeaderLockupStyle)
        ctx.theme.registerStyle("ops-search-slot", dev.lingvo.ops.components.OpsSearchSlotStyle)
        ctx.theme.registerStyle("ops-identity", dev.lingvo.ops.components.OpsIdentityStyle)
        ctx.theme.registerStyle("ops-desktop-nav", dev.lingvo.ops.components.OpsDesktopNavStyle)
        ctx.theme.registerStyle("ops-mobile-toggle", dev.lingvo.ops.components.OpsMobileToggleStyle)
        ctx.theme.registerStyle("ops-mobile-nav", dev.lingvo.ops.components.OpsMobileNavStyle)
        ctx.theme.registerStyle("ops-nav-item", dev.lingvo.ops.components.OpsNavItemStyle)
        ctx.theme.registerStyle("ops-content", dev.lingvo.ops.components.OpsContentStyle)
        ctx.theme.registerStyle("ops-skip-link", dev.lingvo.ops.components.OpsSkipLinkStyle)
        ctx.theme.registerStyle("ops-auth-root", dev.lingvo.ops.pages.OpsAuthRootStyle)
        ctx.theme.registerStyle("ops-auth-card", dev.lingvo.ops.pages.OpsAuthCardStyle)
        ctx.theme.registerStyle("ops-auth-lockup", dev.lingvo.ops.pages.OpsAuthLockupStyle)
        ctx.theme.registerStyle("l-empty-state", dev.lingvo.site.ds.LEmptyStateStyle)
        ctx.theme.registerStyle("l-empty-state-content", dev.lingvo.site.ds.LEmptyStateContentStyle)
        ctx.theme.registerStyle("l-date-range", dev.lingvo.site.ds.LDateRangeStyle)
        ctx.theme.registerStyle("l-date-range-field", dev.lingvo.site.ds.LDateRangeFieldStyle)
        ctx.theme.registerStyle("l-date-range-input", dev.lingvo.site.ds.LDateRangeInputStyle)
        ctx.theme.registerStyle("l-date-range-value", dev.lingvo.site.ds.LDateRangeValueStyle)
        ctx.theme.registerStyle("l-date-range-arrow", dev.lingvo.site.ds.LDateRangeArrowStyle)
        ctx.theme.registerStyle("l-date-range-caption", dev.lingvo.site.ds.LDateRangeCaptionStyle)
        ctx.theme.registerStyle("l-divider", dev.lingvo.site.ds.LDividerStyle)
        ctx.theme.registerStyle("l-progress-bar", dev.lingvo.site.ds.LProgressBarStyle)
        ctx.theme.registerStyle("l-progress-cells", dev.lingvo.site.ds.LProgressCellsStyle)
        ctx.theme.registerStyle("l-progress-cell", dev.lingvo.site.ds.LProgressCellStyle)
        ctx.theme.registerStyle("l-progress-empty-cell", dev.lingvo.site.ds.LProgressEmptyCellStyle)
        ctx.theme.registerStyle("l-progress-translated-cell", dev.lingvo.site.ds.LProgressTranslatedCellStyle)
        ctx.theme.registerStyle("l-progress-approved-cell", dev.lingvo.site.ds.LProgressApprovedCellStyle)
        ctx.theme.registerStyle("l-progress-counts", dev.lingvo.site.ds.LProgressCountsStyle)
        ctx.theme.registerStyle("l-filter-bar", dev.lingvo.site.ds.LFilterBarStyle)
        ctx.theme.registerStyle("l-filter-chip-row", dev.lingvo.site.ds.LFilterChipRowStyle)
        ctx.theme.registerStyle("l-section-title-icon", dev.lingvo.site.ds.LSectionTitleIconStyle)
        ctx.theme.registerStyle("l-section-heading-icon", dev.lingvo.site.ds.LSectionHeadingIconStyle)
        ctx.theme.registerStyle("l-key-value-row", dev.lingvo.site.ds.LKeyValueRowStyle)
        ctx.theme.registerStyle("l-key-value-row-label", dev.lingvo.site.ds.LKeyValueRowLabelStyle)
        ctx.theme.registerStyle("l-key-value-row-value", dev.lingvo.site.ds.LKeyValueRowValueStyle)
        ctx.theme.registerStyle("l-key-value-row-caption", dev.lingvo.site.ds.LKeyValueRowCaptionStyle)
        ctx.theme.registerStyle("l-key-value-row-link", dev.lingvo.site.ds.LKeyValueRowLinkStyle)
        ctx.theme.registerStyle("l-stat-row-group", dev.lingvo.site.ds.LStatRowGroupStyle)
        ctx.theme.registerStyle("l-stat-row", dev.lingvo.site.ds.LStatRowStyle)
        ctx.theme.registerStyle("l-stat-row-label", dev.lingvo.site.ds.LStatRowLabelStyle)
        ctx.theme.registerStyle("l-stat-row-value", dev.lingvo.site.ds.LStatRowValueStyle)
        ctx.theme.registerStyle("l-toast", dev.lingvo.site.ds.LToastStyle)
        ctx.theme.registerStyle("toast-host", dev.lingvo.site.ds.ToastHostStyle)
        ctx.theme.registerStyle("l-toast-close", dev.lingvo.site.ds.LToastCloseStyle)
        ctx.theme.registerStyle("l-icon-badge", dev.lingvo.site.ds.LIconBadgeStyle)
        ctx.theme.registerStyle("l-avatar", dev.lingvo.site.ds.LAvatarStyle)
        ctx.theme.registerStyle("l-modal", dev.lingvo.site.ds.LModalStyle)
        ctx.theme.registerStyle("l-modal-close", dev.lingvo.site.ds.LModalCloseStyle)
        ctx.theme.registerStyle("l-copy-field", dev.lingvo.site.ds.LCopyFieldStyle)
        ctx.theme.registerStyle("l-copy-field-value", dev.lingvo.site.ds.LCopyFieldValueStyle)
        ctx.theme.registerStyle("l-copy-field-button", dev.lingvo.site.ds.LCopyFieldButtonStyle)
        ctx.theme.registerStyle("l-route-transition", dev.lingvo.site.ds.LRouteTransitionStyle)
        ctx.theme.registerStyle("l-tooltip", dev.lingvo.site.ds.LTooltipStyle)
        ctx.theme.registerStyle("l-task-progress", dev.lingvo.site.ds.LTaskProgressStyle)
        ctx.theme.registerStyle("l-task-progress-hairline", dev.lingvo.site.ds.LTaskProgressHairlineStyle)
        ctx.theme.registerStyle("l-task-progress-done-cell", dev.lingvo.site.ds.LTaskProgressDoneCellStyle)
        ctx.theme.registerStyle("l-task-progress-failed-cell", dev.lingvo.site.ds.LTaskProgressFailedCellStyle)
        ctx.theme.registerStyle("l-task-progress-detail", dev.lingvo.site.ds.LTaskProgressDetailStyle)
        ctx.theme.registerStyle("l-checkbox", dev.lingvo.site.ds.LCheckboxStyle)
        ctx.theme.registerStyle("l-checkbox-box", dev.lingvo.site.ds.LCheckboxBoxStyle)
        ctx.theme.registerStyle("l-checkbox-dash", dev.lingvo.site.ds.LCheckboxDashStyle)
        ctx.theme.registerStyle("l-switch", dev.lingvo.site.ds.LSwitchStyle)
        ctx.theme.registerStyle("l-switch-track", dev.lingvo.site.ds.LSwitchTrackStyle)
        ctx.theme.registerStyle("l-switch-thumb", dev.lingvo.site.ds.LSwitchThumbStyle)
        ctx.theme.registerStyle("l-stat-tile", dev.lingvo.site.ds.LStatTileStyle)
        ctx.theme.registerStyle("l-stat-tile-label", dev.lingvo.site.ds.LStatTileLabelStyle)
        ctx.theme.registerStyle("l-stat-tile-value", dev.lingvo.site.ds.LStatTileValueStyle)
        ctx.theme.registerStyle("l-stat-tile-delta", dev.lingvo.site.ds.LStatTileDeltaStyle)
        ctx.theme.registerStyle("l-table-container", dev.lingvo.site.ds.LTableContainerStyle)
        ctx.theme.registerStyle("l-table", dev.lingvo.site.ds.LTableStyle)
        ctx.theme.registerStyle("l-table-caption", dev.lingvo.site.ds.LTableCaptionStyle)
        ctx.theme.registerStyle("l-table-head", dev.lingvo.site.ds.LTableHeadStyle)
        ctx.theme.registerStyle("l-table-row", dev.lingvo.site.ds.LTableRowStyle)
        ctx.theme.registerStyle("l-table-header-cell", dev.lingvo.site.ds.LTableHeaderCellStyle)
        ctx.theme.registerStyle("l-table-row-header-cell", dev.lingvo.site.ds.LTableRowHeaderCellStyle)
        ctx.theme.registerStyle("l-table-cell", dev.lingvo.site.ds.LTableCellStyle)
        ctx.theme.registerStyle("l-table-selection-cell", dev.lingvo.site.ds.LTableSelectionCellStyle)
        ctx.theme.registerStyle("l-bulk-action-bar", dev.lingvo.site.ds.LBulkActionBarStyle)
        ctx.theme.registerStyle("l-bulk-action-bar-count", dev.lingvo.site.ds.LBulkActionBarCountStyle)
        ctx.theme.registerStyle("l-bulk-action-bar-note", dev.lingvo.site.ds.LBulkActionBarNoteStyle)
        ctx.theme.registerStyle("l-project-mark", dev.lingvo.site.ds.LProjectMarkStyle)
        ctx.theme.registerStyle("l-project-image", dev.lingvo.site.ds.LProjectImageStyle)
        ctx.theme.registerStyle("l-alert", dev.lingvo.site.ds.LAlertStyle)
        ctx.theme.registerStyle("l-alert-dismiss", dev.lingvo.site.ds.LAlertDismissStyle)
        ctx.theme.registerStyle("l-menu-root", dev.lingvo.site.ds.LMenuRootStyle)
        ctx.theme.registerStyle("l-menu-scrim", dev.lingvo.site.ds.LMenuScrimStyle)
        ctx.theme.registerStyle("l-menu", dev.lingvo.site.ds.LMenuStyle)
        ctx.theme.registerStyle("l-menu-item", dev.lingvo.site.ds.LMenuItemStyle)
        ctx.theme.registerStyle("l-menu-item-label", dev.lingvo.site.ds.LMenuItemLabelStyle)
        ctx.theme.registerStyle("l-menu-item-description", dev.lingvo.site.ds.LMenuItemDescriptionStyle)
        ctx.theme.registerStyle("l-menu-item-shortcut", dev.lingvo.site.ds.LMenuItemShortcutStyle)
        ctx.theme.registerStyle("l-menu-item-check", dev.lingvo.site.ds.LMenuItemCheckStyle)
        ctx.theme.registerStyle("l-menu-group-title", dev.lingvo.site.ds.LMenuGroupTitleStyle)
        ctx.theme.registerStyle("l-menu-separator", dev.lingvo.site.ds.LMenuSeparatorStyle)
        ctx.theme.registerStyle("l-breadcrumbs", dev.lingvo.site.ds.LBreadcrumbsStyle)
        ctx.theme.registerStyle("l-breadcrumbs-list", dev.lingvo.site.ds.LBreadcrumbsListStyle)
        ctx.theme.registerStyle("l-breadcrumb-item", dev.lingvo.site.ds.LBreadcrumbItemStyle)
        ctx.theme.registerStyle("l-breadcrumb-link", dev.lingvo.site.ds.LBreadcrumbLinkStyle)
        ctx.theme.registerStyle("l-breadcrumb-current", dev.lingvo.site.ds.LBreadcrumbCurrentStyle)
        ctx.theme.registerStyle("l-breadcrumb-separator", dev.lingvo.site.ds.LBreadcrumbSeparatorStyle)
        ctx.theme.registerStyle("l-card", dev.lingvo.site.ds.LCardStyle)
        ctx.theme.registerStyle("l-card-link", dev.lingvo.site.ds.LCardLinkStyle)
        ctx.theme.registerStyle("l-disclosure", dev.lingvo.site.ds.LDisclosureStyle)
        ctx.theme.registerStyle("l-disclosure-header", dev.lingvo.site.ds.LDisclosureHeaderStyle)
        ctx.theme.registerStyle("l-disclosure-caret", dev.lingvo.site.ds.LDisclosureCaretStyle)
        ctx.theme.registerStyle("l-disclosure-panel", dev.lingvo.site.ds.LDisclosurePanelStyle)
        ctx.theme.registerStyle("page-header", dev.lingvo.site.ds.PageHeaderStyle)
        ctx.theme.registerStyle("page-header-mark", dev.lingvo.site.ds.PageHeaderMarkStyle)
        ctx.theme.registerStyle("l-skeleton", dev.lingvo.site.ds.LSkeletonStyle)
        ctx.theme.registerStyle("l-spinner", dev.lingvo.site.ds.LSpinnerStyle)
        ctx.theme.registerStyle("l-select", dev.lingvo.site.ds.LSelectStyle)
        ctx.theme.registerStyle("l-select-icon", dev.lingvo.site.ds.LSelectIconStyle)
        ctx.theme.registerStyle("l-steps", dev.lingvo.site.ds.LStepsStyle)
        ctx.theme.registerStyle("l-step", dev.lingvo.site.ds.LStepStyle)
        ctx.theme.registerStyle("l-step-marker", dev.lingvo.site.ds.LStepMarkerStyle)
        ctx.theme.registerStyle("l-step-label", dev.lingvo.site.ds.LStepLabelStyle)
        ctx.theme.registerStyle("l-step-description", dev.lingvo.site.ds.LStepDescriptionStyle)
        ctx.theme.registerStyle("glyph-mosaic", dev.lingvo.site.ds.GlyphMosaicStyle)
        ctx.theme.registerStyle("glyph-mosaic-item", dev.lingvo.site.ds.GlyphMosaicItemStyle)
        ctx.theme.registerStyle("l-search-field", dev.lingvo.site.ds.LSearchFieldStyle)
        ctx.theme.registerStyle("l-search-input", dev.lingvo.site.ds.LSearchInputStyle)
        ctx.theme.registerStyle("l-tabs", dev.lingvo.site.ds.LTabsStyle)
        ctx.theme.registerStyle("l-tab-list-frame", dev.lingvo.site.ds.LTabListFrameStyle)
        ctx.theme.registerStyle("l-tab-list", dev.lingvo.site.ds.LTabListStyle)
        ctx.theme.registerStyle("l-tab", dev.lingvo.site.ds.LTabStyle)
        ctx.theme.registerStyle("l-segmented", dev.lingvo.site.ds.LSegmentedStyle)
        ctx.theme.registerStyle("l-segmented-button", dev.lingvo.site.ds.LSegmentedButtonStyle)
        ctx.theme.registerStyle("l-chip", dev.lingvo.site.ds.LChipStyle)
        ctx.theme.registerStyle("l-chip-remove", dev.lingvo.site.ds.LChipRemoveStyle)
        ctx.theme.registerStyle("l-toggle-chip", dev.lingvo.site.ds.LToggleChipStyle)
        ctx.theme.registerStyle("l-toggle-chip-count", dev.lingvo.site.ds.LToggleChipCountStyle)
        ctx.theme.registerStyle("l-field-label", dev.lingvo.site.ds.LFieldLabelStyle)
        ctx.theme.registerStyle("l-text-field-frame", dev.lingvo.site.ds.LTextFieldFrameStyle)
        ctx.theme.registerStyle("l-text-field-input", dev.lingvo.site.ds.LTextFieldInputStyle)
        ctx.theme.registerStyle("l-field-error", dev.lingvo.site.ds.LFieldErrorStyle)
        ctx.theme.registerStyle("l-text-area", dev.lingvo.site.ds.LTextAreaStyle)
        ctx.theme.registerStyle("l-chord", dev.lingvo.site.ds.LChordStyle)
        ctx.theme.registerStyle("l-conflict-card", dev.lingvo.site.ds.LConflictCardStyle)
        ctx.theme.registerStyle("l-conflict-version", dev.lingvo.site.ds.LConflictVersionStyle)
        ctx.theme.registerStyle("l-conflict-label", dev.lingvo.site.ds.LConflictLabelStyle)
        ctx.theme.registerStyle("l-button", dev.lingvo.site.ds.LButtonStyle)
        ctx.theme.registerStyle("l-button-icon", dev.lingvo.site.ds.LButtonIconStyle)
        ctx.theme.registerStyle("l-icon-button-hit-area", dev.lingvo.site.ds.LIconButtonHitAreaStyle)
        ctx.theme.registerStyle("l-code-block", dev.lingvo.site.ds.LCodeBlockStyle)
        ctx.theme.registerStyle("l-code-block-header", dev.lingvo.site.ds.LCodeBlockHeaderStyle)
        ctx.theme.registerStyle("l-code-block-pre", dev.lingvo.site.ds.LCodeBlockPreStyle)
        ctx.theme.registerStyle("l-visually-hidden", dev.lingvo.site.ds.LVisuallyHiddenStyle)
        ctx.theme.registerStyle("l-field-group", dev.lingvo.site.ds.LFieldGroupStyle)
        ctx.theme.registerStyle("l-badge", dev.lingvo.site.ds.LBadgeStyle)
        ctx.theme.registerStyle("l-badge-leading", dev.lingvo.site.ds.LBadgeLeadingStyle)
        ctx.theme.registerStyle("l-badge-dot", dev.lingvo.site.ds.LBadgeDotStyle)
        ctx.theme.registerStyle("l-pagination", dev.lingvo.site.ds.LPaginationStyle)
        ctx.theme.registerStyle("l-icon", dev.lingvo.site.ds.LIconStyle)
        ctx.theme.registerStyle("l-reveal", dev.lingvo.site.ds.LRevealStyle)
        ctx.theme.registerStyle("l-progress-ring", dev.lingvo.site.ds.LProgressRingStyle)
        ctx.theme.registerStyle("l-progress-ring-label", dev.lingvo.site.ds.LProgressRingLabelStyle)
        ctx.theme.registerStyle("l-kbd", dev.lingvo.site.ds.LKbdStyle)
        ctx.theme.registerStyle("l-split-button", dev.lingvo.site.ds.LSplitButtonStyle)
        ctx.theme.registerStyle("l-split-button-primary", dev.lingvo.site.ds.LSplitButtonPrimaryStyle)
        ctx.theme.registerStyle("l-split-button-divider", dev.lingvo.site.ds.LSplitButtonDividerStyle)
        ctx.theme.registerStyle("l-split-button-trigger", dev.lingvo.site.ds.LSplitButtonTriggerStyle)
        ctx.theme.registerStyle("l-split-button-menu", dev.lingvo.site.ds.LSplitButtonMenuStyle)
        ctx.theme.registerKeyframes("l-route-enter", dev.lingvo.site.ds.LRouteEnter)
        ctx.theme.registerKeyframes("l-skeleton-shimmer", dev.lingvo.site.ds.LSkeletonShimmer)
        ctx.theme.registerKeyframes("l-spinner-rotation", dev.lingvo.site.ds.LSpinnerRotation)
        ctx.theme.registerKeyframes("glyph-mosaic-settle", dev.lingvo.site.ds.GlyphMosaicSettle)
        ctx.theme.registerKeyframes("l-reveal-up", dev.lingvo.site.ds.LRevealUp)
        ctx.theme.registerKeyframes("l-reveal-left", dev.lingvo.site.ds.LRevealLeft)
        ctx.theme.registerKeyframes("l-reveal-settle", dev.lingvo.site.ds.LRevealSettle)
        dev.lingvo.site.ds.initLingvoTheme(ctx)
        dev.lingvo.site.i18n.initI18n(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        dev.lingvo.ops.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
